import { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { MainLayout } from "../components/layout/MainLayout";
import { Header } from "../components/layout/Header";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/ui/table";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import {
  Search,
  Plus,
  Save,
  Calendar,
  User,
  AlertCircle,
  CheckCircle2,
  TrendingDown,
  Trash2,
  X,
  Zap,
  Package,
  AlertTriangle,
  ArrowLeft,
} from "lucide-react";
import { cn } from "../lib/utils";
import { retrieveData } from "../LocalConnection/LocalConnection.js";
import {
  get_item_acc_to_department_master_data,
  get_department_with_categories,
  save_update_adjustment,
  server_post_data,
} from "../ServiceConnection/serviceconnection";
import { handleError, handleSuccess } from "../CommonJquery/CommonJquery.js";

import Loader from "../components/layout/Loader.js";

export default function AdjustmentScreen() {
  const navigate = useNavigate();
  const searchInputRef = useRef(null);
  const suggestionsRef = useRef(null);

  // State management
  const [adjustmentItems, setAdjustmentItems] = useState([]);
  const [adjustmentNotes, setAdjustmentNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [showLoaderAdmin, setShowLoaderAdmin] = useState(false);

  // Search and items
  const [searchQuery, setSearchQuery] = useState("");
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(0);
  const [masterItemList, setMasterItemList] = useState([]);
  const [justAddedItem, setJustAddedItem] = useState(null);

  // Reason dialog
  const [showReasonDialog, setShowReasonDialog] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [reasonText, setReasonText] = useState("");

  // User info
  const [userName, setUserName] = useState("");
  const userId = retrieveData("user_id") || "—";

   // User info
    const [auditorName, setauditorName] = useState("");
    const auditorId = retrieveData("user_id") || "—";
    const [selectedDepartment, setSelectedDepartment] = useState("Kitchen");
    const [selectedDepartmentID, setSelectedDepartmentID] = useState("0");
    const [selectedDepartmentIndex, setSelectedDepartmentIndex] = useState("0");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedCategoryIndex, setSelectedCategoryIndex] = useState("0");
    const [selectedCategoryID, setSelectedCategoryID] = useState("0");
    const [selectedVendor, setSelectedVendor] = useState("");
    const [selectedVendorID, setSelectedVendorID] = useState("0");
    const [SelectedVendorIndex, setSelectedVendorIndex] = useState("0");
    const [poItems, setPOItems] = useState([]);
    const [categories, setcategories] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [remarks, setRemarks] = useState("");
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [adminName, setadminName] = useState("");
    const [unitTypes, setUnitTypes] = useState([]);
  
    const handleDepartmentChange = (index) => {
      console.log("Selected department index:", departments[index]);
      setSelectedDepartment(departments[index].department_id);
      setSelectedDepartmentIndex(index);
      setSelectedDepartmentID(departments[index].department_id);
      setSelectedVendor("");
      setSelectedVendorIndex("0");
      setSelectedVendorID("0");
      setSelectedCategory("");
      setSelectedCategoryIndex("0");
      setSelectedCategoryID("0");
      setcategories(departments[index].categories);
      setAdjustmentItems([]);
      setSearchQuery("");
      setShowSuggestions(false);
      item_data_get(departments[index].department_id);
    };

  const adjustmentDate = new Date().toLocaleDateString("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  // Load master data on mount
  useEffect(() => {
    master_data_get();
  }, []);

  // Auto-focus search input
  useEffect(() => {
    if (searchInputRef.current && !showSearchDropdown) {
      searchInputRef.current.focus();
    }
  }, [showSearchDropdown]);

  // Scroll selected suggestion into view
  useEffect(() => {
    if (suggestionsRef.current && showSearchDropdown) {
      const selectedElement =
        suggestionsRef.current.children[selectedSuggestionIndex];
      if (selectedElement) {
        selectedElement.scrollIntoView({
          block: "nearest",
          behavior: "smooth",
        });
      }
    }
  }, [selectedSuggestionIndex, showSearchDropdown]);

  const item_data_get = async (department_id) => {
      setauditorName(retrieveData("admin_name"));
      
  
      const fd = new FormData();
      fd.append("status", "all");
      fd.append("search", "");
      fd.append("department_id",department_id);
  
      try {
        const response = await server_post_data(get_item_acc_to_department_master_data, fd);
  
        if (response.data.error) {
          handleError(response.data.message.data);
        } else {
          const items = response.data.message.items || [];
            console.log("Items fetched:", items);
           setMasterItemList(items || []);
           
        }
      } catch (error) {
        handleError("network");
      } finally {
        setShowLoaderAdmin(false);
      }
    };

  // Get master data from API
  const master_data_get = async () => {
    setUserName(retrieveData("admin_name"));
    setShowLoaderAdmin(true);

    const fd = new FormData();
    fd.append("status", "all");
    fd.append("search", "");

    try {
      const response = await server_post_data(get_department_with_categories, fd);

      if (response.data.error) {
        handleError(response.data.message);
      } else {
        const departments_dta = response.data.message.data || [];
          console.log("Departments fetched:", departments_dta);
          setDepartments(departments_dta);
        //   const { items } = response.data.message;
        // setmasterItemList(items || []);
          // auto-select first department safely
          if (departments_dta.length > 0) {
            setSelectedDepartment(departments_dta[0].department_name);
            setSelectedDepartmentID(departments_dta[0].primary_id);
            setcategories(departments_dta[0].categories || []);
          }
      }
    } catch (error) {
      handleError("network");
    } finally {
      setShowLoaderAdmin(false);
    }
  };

  // Search items function
  const searchItems = (query) => {
    const lowercaseQuery = query.toLowerCase();
    return masterItemList.filter((item) =>
      item.name.toLowerCase().includes(lowercaseQuery),
    );
  };

  // Get search suggestions
  const searchSuggestions =
    searchQuery.length >= 2 ? searchItems(searchQuery).slice(0, 10) : [];

  // Handle search input change
  const handleSearch = useCallback((query) => {
    setSearchQuery(query);
    setShowSearchDropdown(true);
    setSelectedSuggestionIndex(0);
  }, []);

  // Handle add item
  const handleAddItem = useCallback(
    (item) => {
      const existing = adjustmentItems.find((a) => a.ingredient_id === item.id);
      if (existing) {
        setJustAddedItem(item.id);
        setTimeout(() => setJustAddedItem(null), 1000);
        return;
      }

      const newAdjustmentItem = {
        id: Date.now().toString(),
        itemId: item.id, // ✅ itemId field
        ingredient_id: item.id,
        name: item.name, // ✅ name field
        current_stock: item.currentStock,
        adjustment_qty: "", // User will enter this
        unit: item.unit, // ✅ unit field
        default_unit_id: item.default_unit_id,
        type: "Loss", // ✅ Default type
        reason: "",
      };

      setAdjustmentItems((prev) => [...prev, newAdjustmentItem]);

      // Show success feedback
      setJustAddedItem(item.id);
      setTimeout(() => setJustAddedItem(null), 1000);

      // Clear search
      setSearchQuery("");
      setShowSearchDropdown(false);
      setSelectedSuggestionIndex(0);

      // Refocus search input
      setTimeout(() => {
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }, 100);
    },
    [adjustmentItems],
  );

  // Keyboard navigation
  const handleKeyDown = useCallback(
    (e) => {
      if (!showSearchDropdown || searchSuggestions.length === 0) return;

      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          setSelectedSuggestionIndex((prev) =>
            prev < searchSuggestions.length - 1 ? prev + 1 : prev,
          );
          break;
        case "ArrowUp":
          e.preventDefault();
          setSelectedSuggestionIndex((prev) => (prev > 0 ? prev - 1 : 0));
          break;
        case "Enter":
          e.preventDefault();
          if (searchSuggestions[selectedSuggestionIndex]) {
            handleAddItem(searchSuggestions[selectedSuggestionIndex]);
          }
          break;
        case "Escape":
          e.preventDefault();
          setShowSearchDropdown(false);
          setSearchQuery("");
          setSelectedSuggestionIndex(0);
          break;
        default:
          break;
      }
    },
    [
      showSearchDropdown,
      searchSuggestions,
      selectedSuggestionIndex,
      handleAddItem,
    ],
  );

  // Handle adjustment quantity change
  const handleAdjustmentQtyChange = useCallback((itemId, value) => {
    setAdjustmentItems((prevItems) =>
      prevItems.map((item) =>
        item.ingredient_id === itemId
          ? { ...item, adjustment_qty: value }
          : item,
      ),
    );
  }, []);

  // Handle type change
  const handleTypeChange = useCallback((itemId, newType) => {
    setAdjustmentItems((prevItems) =>
      prevItems.map((item) =>
        item.ingredient_id === itemId ? { ...item, type: newType } : item,
      ),
    );
  }, []);

  // Open reason dialog
  const handleOpenReasonDialog = (itemId, currentReason) => {
    setSelectedItemId(itemId);
    setReasonText(currentReason);
    setShowReasonDialog(true);
  };

  // Save reason
  const handleSaveReason = () => {
    setAdjustmentItems((prevItems) =>
      prevItems.map((item) =>
        item.ingredient_id === selectedItemId
          ? { ...item, reason: reasonText }
          : item,
      ),
    );
    setShowReasonDialog(false);
    setReasonText("");
    setSelectedItemId(null);
  };

  // Remove item
  const handleRemoveItem = (itemId) => {
    setAdjustmentItems(
      adjustmentItems.filter((item) => item.ingredient_id !== itemId),
    );
  };

  // Calculate stats
  const stats = {
    totalItems: adjustmentItems.length,
    totalReduced: adjustmentItems
      .filter((i) => i.type === "Loss")
      .reduce((sum, i) => sum + (parseFloat(i.adjustment_qty) || 0), 0),
    totalGain: adjustmentItems
      .filter((i) => i.type === "Gain")
      .reduce((sum, i) => sum + (parseFloat(i.adjustment_qty) || 0), 0),
  };

  // Truncate reason text
  const truncateReason = (text, words = 4) => {
    if (!text) return "";
    const textArray = text.split(" ");
    if (textArray.length > words) {
      return textArray.slice(0, words).join(" ") + "...";
    }
    return text;
  };

  // Get stock display
  const getStockDisplay = (item) => {
    return `${item.currentStock} ${item.unit}`;
  };

  // Get stock badge
  const getStockBadge = (item) => {
    const masterItem = masterItemList.find((m) => m.id === item.ingredient_id);
    if (!masterItem) return null;

    if (masterItem.currentStock <= 0) {
      return (
        <Badge variant="destructive" className="text-[10px]">
          Out
        </Badge>
      );
    } else if (masterItem.currentStock <= masterItem.minStock) {
      return (
        <Badge className="text-[10px] bg-amber-100 text-amber-700 border-amber-300">
          Low
        </Badge>
      );
    }
    return (
      <Badge className="text-[10px] bg-emerald-100 text-emerald-700 border-emerald-300">
        In Stock
      </Badge>
    );
  };

  // Handle submit adjustment - with proper API data format
  // Handle submit adjustment - with proper API data format
  const handleSubmitAdjustment = async () => {
    if (adjustmentItems.length === 0) {
      alert("Please add at least one adjustment item");
      return;
    }

    // Validate all items have reasons (mandatory for adjustment)
    const itemsWithoutReason = adjustmentItems.filter((i) => !i.reason?.trim());
    if (itemsWithoutReason.length > 0) {
      alert("Please add reason for all items");
      return;
    }

    // Validate all items have non-zero adjustment quantities
    const itemsWithoutQty = adjustmentItems.filter(
      (i) => !i.adjustment_qty || parseFloat(i.adjustment_qty) === 0,
    );
    if (itemsWithoutQty.length > 0) {
      alert("Please enter a non-zero adjustment quantity for all items");
      return;
    }

    setLoading(true);

    const formattedItems = adjustmentItems.map((item) => {
      // Clean ingredient_id → remove "ING" prefix and convert to integer
      let cleanId = item.ingredient_id;
      if (
        typeof cleanId === "string" &&
        cleanId.toUpperCase().startsWith("ING")
      ) {
        cleanId = parseInt(cleanId.slice(3), 10) || 0;
      } else {
        cleanId = parseInt(cleanId, 10) || 0;
      }

      return {
        id: item.id, // temporary frontend id (string)
        itemId: String(item.itemId), // keep original (may have ING)
        ingredient_id: cleanId, // ← number (critical fix)
        name: item.name,
        adjustment_qty: parseFloat(item.adjustment_qty) || 0,
        unit: item.unit || "",
        default_unit_id: String(item.default_unit_id || ""),
        type: item.type, // "Loss" or "Gain"
        reason: item.reason.trim() || "",
        // Optional: if backend strictly needs these renamed fields
        // difference_type: item.type,
        // item_unit_type: item.unit,
      };
    });

    const fd = new FormData();

    fd.append("adjustment_id", "0");
    fd.append("department_id", selectedDepartmentID);
    fd.append("adjustment_date", new Date().toISOString()); // ok – backend ignores?
    fd.append("user_name", userName);
    fd.append("user_id", userId);
    fd.append("adjustment_notes", adjustmentNotes);
    fd.append("total_items", adjustmentItems.length);
    fd.append("total_loss", stats.totalReduced);
    fd.append("total_gain", stats.totalGain);
    fd.append("items", JSON.stringify(formattedItems));

    try {
      const response = await server_post_data(save_update_adjustment, fd);

      if (response.data.error) {
        handleError(response.data.message);
      } else {
        handleSuccess("Success", "Adjustment submitted successfully!");
        navigate("/adjustments");
      }
    } catch (error) {
      handleError("network");
    } finally {
      handleError("network");
      setLoading(false);
    }
  };

  // Get low stock items
  const lowStockItems = masterItemList
    .filter((item) => item.currentStock <= item.minStock)
    .slice(0, 5);

  return (
    <MainLayout>
      <Header
        title="Create Adjustment"
        subtitle="Fast keyboard-driven workflow → Type, Arrow keys, Enter to add"
      />
      {(showLoaderAdmin || loading) && <Loader />}

      <div className="p-6 space-y-2">
        {/* Header with back button and workflow */}
        <div className="flex items-center justify-between">
          <Button
            variant="ghost"
            onClick={() => navigate("/adjustments")}
            className="gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </Button>
          <div className="flex items-center gap-2 text-xs">
            <span className="px-3 py-1.5 rounded-full bg-primary text-primary-foreground font-medium">
              1. Create
            </span>
            <span className="text-muted-foreground">→</span>
            <span className="px-3 py-1.5 rounded-full bg-muted text-muted-foreground">
              2. View
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Main Content - 3 columns */}
          <div className="lg:col-span-3 space-y-6">
            {/* Header Info */}
            <Card>
              <CardContent className="pt-6">
                <div className="grid grid-cols-3 gap-4">
                  <div className="space-y-2">
                    <Label className="text-xs">Adjusted By</Label>
                    <Input
                      value={userName}
                      disabled
                      className="h-9 text-sm bg-muted"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-xs">Date</Label>
                    <Input
                      value={adjustmentDate}
                      disabled
                      className="h-9 text-sm bg-muted"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-xs">User ID</Label>
                    <Input
                      value={userId}
                      disabled
                      className="h-9 text-sm bg-muted"
                    />
                  </div>
                  <div className="space-y-2">
                                    <Label className="text-xs">Department *</Label>
                                    <Select
                                      value={selectedDepartmentIndex}
                                      onValueChange={handleDepartmentChange}
                                    >
                                      <SelectTrigger className="h-9 text-sm">
                                        <SelectValue />
                                      </SelectTrigger>
                                      <SelectContent>
                                        {departments.map((dept, index) => (
                                          <SelectItem key={index} value={index}>
                                            {dept.department_name}
                                          </SelectItem>
                                        ))}
                                      </SelectContent>
                                    </Select>
                    </div>
                </div>
              </CardContent>
            </Card>

            {/* QUICK ADD SECTION - Prominent & Large */}
            <Card className="border-2 border-primary/20">
              <CardHeader className="pb-3">
                <div className="flex items-center gap-2">
                  <Zap className="w-5 h-5 text-primary" />
                  <CardTitle className="text-lg">Quick Add Items</CardTitle>
                </div>
                <CardDescription>
                  Type to search → Use ↑↓ arrows → Press Enter to add
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                {/* Large Search Input */}
                <div className="relative">
                  <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
                  <Input
                    ref={searchInputRef}
                    placeholder="Search items... (Type 2+ characters)"
                    value={searchQuery}
                    onChange={(e) => handleSearch(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onFocus={() =>
                      searchQuery.length >= 2 && setShowSearchDropdown(true)
                    }
                    className="h-12 pl-12 pr-12 text-base border-2 focus:border-primary"
                  />
                  {searchQuery && (
                    <Button
                      variant="ghost"
                      size="sm"
                      className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 p-0"
                      onClick={() => {
                        setSearchQuery("");
                        setShowSearchDropdown(false);
                        setSelectedSuggestionIndex(0);
                        searchInputRef.current?.focus();
                      }}
                    >
                      <X className="w-4 h-4" />
                    </Button>
                  )}
                </div>

                {/* Search Suggestions - Keyboard Navigable */}
                {showSearchDropdown && searchSuggestions.length > 0 && (
                  <div
                    ref={suggestionsRef}
                    className="border-2 border-primary/30 rounded-lg overflow-hidden max-h-[320px] overflow-y-auto bg-card"
                  >
                    {searchSuggestions.map((item, index) => {
                      const isAdded = adjustmentItems.some(
                        (a) => a.ingredient_id === item.id,
                      );
                      const isSelected = index === selectedSuggestionIndex;
                      const isJustAdded = justAddedItem === item.id;
                      const isLowStock = item.currentStock <= item.minStock;
                      const isOutOfStock = item.currentStock <= 0;

                      return (
                        <button
                          key={item.id}
                          className={cn(
                            "w-full px-4 py-3 text-left flex items-center justify-between gap-3 border-b border-border last:border-0 transition-all",
                            isSelected &&
                              "bg-primary/10 border-l-4 border-l-primary",
                            isAdded && "opacity-60 cursor-not-allowed",
                            isJustAdded && "bg-success/20 animate-pulse",
                            !isSelected && !isAdded && "hover:bg-muted/50",
                          )}
                          onClick={() => !isAdded && handleAddItem(item)}
                          disabled={isAdded}
                        >
                          <div className="flex items-center gap-3 flex-1">
                            {isAdded ? (
                              <CheckCircle2 className="w-5 h-5 text-success flex-shrink-0" />
                            ) : (
                              <Plus
                                className={cn(
                                  "w-5 h-5 flex-shrink-0",
                                  isSelected
                                    ? "text-primary"
                                    : "text-muted-foreground",
                                )}
                              />
                            )}
                            <div className="flex-1">
                              <p className="font-semibold text-sm">
                                {item.name}
                              </p>
                              <div className="flex items-center gap-2 mt-0.5">
                                <span className="text-xs text-muted-foreground">
                                  {item.category}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <div className="text-right">
                              <div className="flex items-center gap-1.5">
                                <Package
                                  className={cn(
                                    "w-4 h-4",
                                    isOutOfStock && "text-destructive",
                                    isLowStock &&
                                      !isOutOfStock &&
                                      "text-amber-500",
                                    !isLowStock &&
                                      !isOutOfStock &&
                                      "text-emerald-500",
                                  )}
                                />
                                <span
                                  className={cn(
                                    "text-sm font-bold",
                                    isOutOfStock && "text-destructive",
                                    isLowStock &&
                                      !isOutOfStock &&
                                      "text-amber-600",
                                    !isLowStock &&
                                      !isOutOfStock &&
                                      "text-emerald-600",
                                  )}
                                >
                                  {getStockDisplay(item)}
                                </span>
                              </div>
                            </div>
                            {(isLowStock || isOutOfStock) && (
                              <AlertTriangle
                                className={cn(
                                  "w-4 h-4",
                                  isOutOfStock
                                    ? "text-destructive"
                                    : "text-amber-500",
                                )}
                              />
                            )}
                          </div>
                        </button>
                      );
                    })}
                  </div>
                )}

                {showSearchDropdown &&
                  searchQuery.length >= 2 &&
                  searchSuggestions.length === 0 && (
                    <div className="border-2 border-dashed rounded-lg p-6 text-center">
                      <p className="text-muted-foreground">
                        No items found matching "{searchQuery}"
                      </p>
                    </div>
                  )}

                {/* Help Text */}
                <div className="bg-muted/50 rounded-lg p-3">
                  <p className="text-xs text-muted-foreground flex items-center gap-2">
                    <span className="font-semibold text-foreground">
                      💡 Quick Tips:
                    </span>
                    Use ↑↓ arrows to navigate • Press Enter to add • Esc to
                    close • Auto-focuses after each add
                  </p>
                </div>
              </CardContent>
            </Card>

            {/* Adjustment Notes */}
            <Card>
              <CardHeader>
                <CardTitle>Adjustment Notes</CardTitle>
                <CardDescription>
                  Add general notes about this adjustment (Optional)
                </CardDescription>
              </CardHeader>
              <CardContent>
                <Textarea
                  placeholder="Enter any observations or notes about this adjustment..."
                  value={adjustmentNotes}
                  onChange={(e) => setAdjustmentNotes(e.target.value)}
                  rows={4}
                  className="resize-none"
                />
              </CardContent>
            </Card>
          </div>

          {/* Right Sidebar - Summary (Sticky) */}
          <div className="lg:col-span-1">
            <div className="sticky top-6 space-y-4">
              <Card>
                <CardHeader>
                  <CardTitle className="text-base">
                    Adjustment Summary
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="space-y-3">
                    <div className="flex justify-between text-sm">
                      <span className="text-muted-foreground">Total Items</span>
                      <Badge className="bg-primary text-primary-foreground">
                        {stats.totalItems}
                      </Badge>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-muted-foreground">
                        Total Loss
                      </span>
                      <span className="text-red-600 font-bold">
                        {stats.totalReduced.toFixed(2)}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-muted-foreground">Total Gain</span>
                      <span className="text-green-600 font-bold">
                        {stats.totalGain.toFixed(2)}
                      </span>
                    </div>
                  </div>

                  <Button
                    className="w-full gap-2"
                    disabled={adjustmentItems.length === 0 || loading}
                    onClick={handleSubmitAdjustment}
                  >
                    <Save className="w-4 h-4" />
                    {loading ? "Submitting..." : "Submit Adjustment"}
                  </Button>
                </CardContent>
              </Card>

              {/* Low Stock Alerts */}
              {lowStockItems.length > 0 && (
                <Card className="border-amber-200 bg-amber-50/50">
                  <CardHeader>
                    <div className="flex items-center gap-2">
                      <AlertTriangle className="w-4 h-4 text-amber-600" />
                      <CardTitle className="text-sm text-amber-900">
                        Low Stock Alert
                      </CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-2">
                      {lowStockItems.map((item) => (
                        <button
                          key={item.id}
                          onClick={() => handleAddItem(item)}
                          className="w-full text-left p-2 rounded hover:bg-amber-100 transition-colors"
                          disabled={adjustmentItems.some(
                            (a) => a.ingredient_id === item.id,
                          )}
                        >
                          <p className="text-xs font-medium text-amber-900">
                            {item.name}
                          </p>
                          <p className="text-[10px] text-amber-700">
                            {getStockDisplay(item)}
                          </p>
                        </button>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              )}
            </div>
          </div>
        </div>

        {/* ADJUSTMENT ITEMS TABLE */}
        {adjustmentItems.length > 0 && (
          <Card>
            <CardHeader>
              <div className="flex items-center justify-between">
                <CardTitle className="text-lg">
                  Adjustment Items ({adjustmentItems.length})
                </CardTitle>
                <Badge variant="outline" className="bg-primary/10 text-primary">
                  {adjustmentItems.length} items added
                </Badge>
              </div>
            </CardHeader>
            <CardContent>
              <div className="rounded-lg border overflow-x-auto">
                <Table>
                  <TableHeader>
                    <TableRow className="bg-muted/50">
                      <TableHead className="text-muted-foreground">
                        Item
                      </TableHead>
                      <TableHead className="text-center text-muted-foreground">
                        Current Stock
                      </TableHead>
                      <TableHead className="text-center text-muted-foreground">
                        Adj Qty
                      </TableHead>
                      <TableHead className="text-center text-muted-foreground">
                        Type
                      </TableHead>
                      <TableHead className="text-muted-foreground">
                        Reason
                      </TableHead>
                      <TableHead className="text-center text-muted-foreground">
                        Action
                      </TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {adjustmentItems.map((item) => (
                      <TableRow
                        key={item.ingredient_id}
                        className="hover:bg-muted/30"
                      >
                        <TableCell className="font-medium">
                          <div className="flex items-center gap-2">
                            <div>
                              <p className="font-medium">{item.name}</p>
                            </div>
                            {getStockBadge(item)}
                          </div>
                        </TableCell>
                        <TableCell className="text-center">
                          <span className="font-semibold">
                            {item.current_stock} {item.unit}
                          </span>
                        </TableCell>
                        <TableCell className="text-center">
                          <div className="flex items-center justify-center gap-2">
                            <Input
                              type="number"
                              min="0"
                              step="0.01"
                              value={item.adjustment_qty}
                              onChange={(e) =>
                                handleAdjustmentQtyChange(
                                  item.ingredient_id,
                                  e.target.value,
                                )
                              }
                              placeholder="0"
                              className="w-20 text-center"
                            />
                            <span className="text-sm text-muted-foreground min-w-12">
                              {item.unit}
                            </span>
                          </div>
                        </TableCell>
                        <TableCell className="text-center">
                          <Select
                            value={item.type}
                            onValueChange={(newType) =>
                              handleTypeChange(item.ingredient_id, newType)
                            }
                          >
                            <SelectTrigger className="w-24 h-9">
                              <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="Loss">Loss</SelectItem>
                              <SelectItem value="Gain">Gain</SelectItem>
                            </SelectContent>
                          </Select>
                        </TableCell>
                        <TableCell>
                          <button
                            onClick={() =>
                              handleOpenReasonDialog(
                                item.ingredient_id,
                                item.reason,
                              )
                            }
                            className="text-sm text-muted-foreground hover:text-foreground truncate max-w-xs"
                          >
                            {item.reason
                              ? truncateReason(item.reason)
                              : "Add reason"}
                          </button>
                        </TableCell>
                        <TableCell className="text-center">
                          <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => handleRemoveItem(item.ingredient_id)}
                            className="text-destructive hover:text-destructive hover:bg-destructive/10"
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </CardContent>
          </Card>
        )}
      </div>

      {/* Reason Dialog */}
      <Dialog open={showReasonDialog} onOpenChange={setShowReasonDialog}>
        <DialogContent className="sm:max-w-[500px]">
          <DialogHeader>
            <DialogTitle>Add Reason for Adjustment</DialogTitle>
            <DialogDescription>
              Explain why this inventory adjustment is necessary
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-4">
            <Textarea
              placeholder="Enter reason (e.g., Stock correction, Damaged items removed, Inventory discrepancy, etc.)"
              value={reasonText}
              onChange={(e) => setReasonText(e.target.value)}
              rows={5}
              className="resize-none"
            />
            <div className="text-xs text-muted-foreground">
              When saved, the first few words will be shown in the table. Reason
              is mandatory for adjustments.
            </div>
          </div>

          <DialogFooter className="gap-2 sm:gap-0">
            <Button
              variant="outline"
              onClick={() => {
                setShowReasonDialog(false);
                setReasonText("");
                setSelectedItemId(null);
              }}
            >
              Cancel
            </Button>
            <Button onClick={handleSaveReason} className="gap-2">
              <Save className="w-4 h-4" />
              Save Reason
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </MainLayout>
  );
}
